<template>
  <div class="purchaseMethod">
    <div class="purchaseMethod_titleArea">
      <h3 class="title">购买方式</h3>
      <span class="tips">根据你的实际情况，选择广告购买的方式。</span>
    </div>
    <div class="purchaseMethod_main">
      <div class="main_left">
        <div class="main_buttonArea">
          <button
            class="button"
            :class="{active:purchase === 'bidding'}"
            @click="purchase = 'bidding'"
          >竞价购买</button>
          <!-- <button
            class="button"
            :class="{active:purchase === 'contract'}"
            @click="purchase = 'contract'"
          >合约购买</button> -->
        </div>
        <div
          v-if="purchase === 'bidding'"
          class="main_card"
        >
          <svg viewBox="0 0 48 48">
            <path
              data-role="secondary"
              d="M27 13H12c-.5523 0-1 .4477-1 1s.4477 1 1 1h15c.5523 0 1-.4477 1-1s-.4477-1-1-1zM34 20v2.1796l-2 1.1547V20H13v10h8.3601a3.7218 3.7218 0 00-.3385 2H13c-1.1046 0-2-.8954-2-2V20c0-1.1046.8954-2 2-2h19c1.1046 0 2 .8954 2 2zM31 13h2c.5523 0 1 .4477 1 1s-.4477 1-1 1h-2c-.5523 0-1-.4477-1-1s.4477-1 1-1z"
            />
            <path
              data-role="primary"
              d="M36 13v6.4934a3.6885 3.6885 0 012-.4904V13c0-2.2091-1.7909-4-4-4H11c-2.2091 0-4 1.7909-4 4v20c0 2.2091 1.7909 4 4 4h12.548l-1.1547-2H11c-1.1046 0-2-.8954-2-2V13c0-1.1046.8954-2 2-2h23c1.1046 0 2 .8954 2 2z"
            />
            <path
              data-role="primary"
              d="M42.924 28.0862l-3.5984-6.2324c-.4713-.8165-1.5153-1.0962-2.3317-.6248l-.0352.0203c-.703.4059-1.0081 1.2364-.7783 1.9805l-10.3882 5.9974c-.532-.4145-1.2832-.4897-1.9032-.1318l-.0352.0204c-.8165.4713-1.0962 1.5153-.6248 2.3317l3.5983 6.2325c.4713.8164 1.5153 1.0961 2.3317.6247l.0352-.0203c.7711-.4451 1.0634-1.4011.6965-2.1937l-.0167-.0307 4.48-2.586 3.2448 5.6195c.463.8018 1.4883 1.0766 2.2901.6136.8019-.4629 1.0766-1.4882.6137-2.2901l-3.2446-5.62 2.9026-1.674c.5296.5703 1.4008.7209 2.1034.3153l.0352-.0203c.8164-.4714 1.0961-1.5154.6248-2.3318z"
            />
          </svg>
          <div class="card_xinxi">
            <h3 class="title">竞价购买广告</h3>
            <p class="tips">通过调整广告曝光单价和设计优质广告创意，与其他客户竞争广告展现机会，根据广告表现最大程度提升广告效果。</p>
          </div>
          <i class="care_icon">√</i>
        </div>

        <div
          v-else
          class="main_card"
        >
          <svg viewBox="0 0 48 48">
            <path
              data-role="secondary"
              d="M14 23c-.5523 0-1 .4477-1 1s.4477 1 1 1h3c.5523 0 1-.4477 1-1s-.4477-1-1-1h-3zM14 28c-.5523 0-1 .4477-1 1s.4477 1 1 1h3c.5523 0 1-.4477 1-1s-.4477-1-1-1h-3zM21 23c-.5523 0-1 .4477-1 1s.4477 1 1 1h3c.5523 0 1-.4477 1-1s-.4477-1-1-1h-3zM21 28c-.5523 0-1 .4477-1 1s.4477 1 1 1h3c.5523 0 1-.4477 1-1s-.4477-1-1-1h-3z"
            />
            <path
              data-role="primary"
              fill-rule="evenodd"
              d="M9 18h27.0614v2.7805c.2979.3933.5485.8245.7432 1.285A4.7454 4.7454 0 0138 21.9003V13c0-2.2091-1.7909-4-4-4h-4V8c0-.5523-.4477-1-1-1s-1 .4477-1 1v1H18V8c0-.5523-.4477-1-1-1s-1 .4477-1 1v1h-5c-2.2091 0-4 1.7909-4 4v20c0 2.2091 1.7909 4 4 4h11.5v-.5572l.0003-.0115c.0113-.4961.0487-.9738.1135-1.4313H11c-1.1046 0-2-.8954-2-2V18zm27-5v3H9v-3c0-1.1046.8954-2 2-2h5v1c0 .5523.4477 1 1 1s1-.4477 1-1v-1h10v1c0 .5523.4477 1 1 1s1-.4477 1-1v-1h4c1.1046 0 2 .8954 2 2z"
              clip-rule="evenodd"
            />
            <path
              data-role="primary"
              d="M31.2756 28.4c2.2092 0 4-1.7909 4-4 0-2.2091-1.7908-4-4-4-2.2091 0-4 1.7909-4 4 0 2.2091 1.7909 4 4 4zM40.8 26.65c0-1.5188-1.2312-2.75-2.75-2.75a2.738 2.738 0 00-1.2769.3138l.0026.1362a5.7308 5.7308 0 01-1.1953 3.5112c.4479.9115 1.3855 1.5388 2.4696 1.5388 1.5188 0 2.75-1.2312 2.75-2.75zM37.9965 36.4542c-.1003-4.378-2.3491-6.567-6.7465-6.567s-6.6462 2.189-6.7465 6.567l-.0004.0259-.0001.0199c0 1.1046.8954 2 2 2h9.494s.0306-.0002.0458-.0005c1.1043-.0253 1.979-.941 1.9537-2.0453zM43 36.7124c-.0016.9877-.8304 1.7876-1.8522 1.7876h-2.2089c.5823-.2725.9249-.8952.9249-1.8092 0-3.4537-.8087-4.3375-1.8638-5.1908 3.8059.3426 5 2.4786 5 5.2124z"
            />
          </svg>
          <div class="card_xinxi">
            <h3 class="title">常规合约</h3>
            <p class="tips">系统将根据定向精准曝光给目标人群。<br> 预定未来1-28天起投的目标人群，支持1-30天投放；单次投放1000起。</p>
          </div>
          <i class="care_icon">√</i>
        </div>

        <!-- <span style="display: inline-block;margin: 14px 0px;">选择素材格式</span> -->

        <!-- <div class="left_card1">
          <div class="card1" :class="{active:materialFormat === 'picture'}" @click="materialFormat = 'picture'">
            <svg
              class="materialIcon-3c_tm9Gz13 adui-icon-base"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="var(--gray-700)"
              data-interactive="false"
              data-icon="image-outlined"
            >
              <path
                d="M14.5 11.6449L12.5474 9.69231L9.90776 12.332L9.90694 12.3404L6.24288 8.67635L3.5 11.4192V14H14.5V11.6449ZM14.5 9.87711V4H3.5V9.65147L6.24188 6.90959L6.24288 6.91059L6.24388 6.90959L9.90314 10.5688L11.6636 8.80843L11.66 8.80488L12.5439 7.921L14.5 9.87711ZM2.5 2.5H15.5C15.7761 2.5 16 2.72386 16 3V15C16 15.2761 15.7761 15.5 15.5 15.5H2.5C2.22386 15.5 2 15.2761 2 15V3C2 2.72386 2.22386 2.5 2.5 2.5ZM8.75 7.25C8.19772 7.25 7.75 6.80228 7.75 6.25C7.75 5.69772 8.19772 5.25 8.75 5.25C9.30228 5.25 9.75 5.69772 9.75 6.25C9.75 6.80228 9.30228 7.25 8.75 7.25Z"
                fill-rule="evenodd"
              />
            </svg>
            <span class="card1_text">图片</span>
            <i class="card1_icon">√</i>
          </div>
          <div class="card1" :class="{active:materialFormat === 'video'}" @click="materialFormat = 'video'">
            <svg
              class="materialIcon-3c_tm9Gz13 adui-icon-base"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="var(--gray-700)"
              data-interactive="false"
              data-icon="video-cam-outlined"
            >
              <path
                d="M13 7.33333L16.2279 4.64343C16.6543 4.28807 17 4.45566 17 4.9954V13.0046C17 13.5543 16.6602 13.7169 16.2279 13.3566L13 10.6667V13.4904C13 13.7718 12.771 14 12.4997 14H1.50035C1.22401 14 1 13.7723 1 13.4904V4.50965C1 4.22818 1.229 4 1.50035 4H12.4997C12.776 4 13 4.22765 13 4.50965V7.33333ZM2.5 5.5V12.5H11.5V5.5H2.5ZM15.5 7.33489L13.5 9.00156L15.5 10.6682V7.33489Z"
                fill-rule="evenodd"
              />
            </svg>
            <span class="card1_text">视频</span>
            <i class="card1_icon">√</i>
          </div>
        </div> -->
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      purchase: 'bidding',
      materialFormat: 'picture'
    }
  }
}
</script>

<style scoped lang="less">
.purchaseMethod {
  width: 100%;
  box-shadow: 0 0 0 1px hsla(0, 0%, 87%, 0.5), 0 3px 6px 0 rgba(0, 0, 0, 0.04);
  background-color: #fff;
  border-radius: 5px;
  padding-bottom: 25px;
  margin-top: 10px;
  .purchaseMethod_titleArea {
    padding: 16px 16px 20px 24px;
    margin-bottom: 8px;
    .title {
      font-size: 14px;
      font-weight: 600;
      color: #1f1f1f;
    }
    .tips {
      margin-top: 4px;
      font-size: 13px;
      color: #6b6b6b;
      display: inline-block;
    }
  }

  .purchaseMethod_main {
    margin: 20px;
    .main_left {
      width: 50%;

      .left_card1 {
        display: flex;
        .card1 {
          margin-right: 12px;
          padding-left: 12px;
          padding-right: 12px;
          min-width: 114px;
          height: 48px;
          width: 114px;
          position: relative;
          border-radius: 4px;
          box-shadow: inset 0 0 0 1px #ebebeb;
          display: flex;
          align-items: center;
          cursor: pointer;

          svg {
            width: 18px;
            height: 18px;
            fill: #ccc;
          }
          .card1_text {
            display: inline-block;
            margin-left: 10px;
          }
          .card1_icon {
            width: 14px;
            height: 14px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-style: normal;
            position: absolute;
            background-color: #ccc;
            color: #fff;
            top: 4px;
            right: 4px;
            display: none;
          }
          &.active {
            background-color: rgba(7, 193, 96, 0.02);
            box-shadow: inset 0 0 0 1px rgb(7 193 96 / 55%);
            svg {
              fill: #07c160;
            }
            .card1_text {
              color: #07c160;
            }
            .card1_icon {
              display: flex;
              background-color: #07c160;
            }
          }
          &:not(.active):hover {
            background-color: #fdfdfd;
            box-shadow: inset 0 0 0 1px #dfdfdf;
            svg {
            }
            .card1_text {
            }
            .card1_icon {
              display: flex;
            }
          }
        }
      }
    }
    .main_buttonArea {
      .button {
        outline: none;
        border: none;
        cursor: pointer;
        color: #1f1f1f;
        background-color: #fff;
        box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.03), 0 0 0 1px #e0e0e0;
        padding: 0px 10px;
        font-size: 13px;
        height: 30px;
        &:first-child {
          border-top-left-radius: 5px;
          border-bottom-left-radius: 5px;
        }
        &:last-child {
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
        }

        &.active {
          background-color: #ebebeb;
          box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.04), 0 0 0 1px #d6d6d6;
        }
        &:not(.active):hover {
          background-color: #ebebeb;
          box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.04), 0 0 0 1px #d6d6d6;
        }
      }
    }

    .main_card {
      color: #07c160;
      font-weight: 600;
      background-color: rgba(7, 193, 96, 0.02);
      box-shadow: inset 0 0 0 1px rgb(7 193 96 / 55%);
      display: flex;
      padding: 18px 16px 18px 12px;
      height: 100%;
      border-radius: 5px;
      margin-top: 18px;
      position: relative;
      svg {
        width: 48px;
        height: 48px;
        fill: #07c160;
      }
      .card_xinxi {
        margin-left: 8px;

        color: #07c160;
        .title {
          margin-bottom: 4px;
          padding-top: 3px;
          font-size: 13px;
          line-height: 20px;
          font-weight: 600;
        }
        .tips {
          font-size: 12px;
        }
      }
      .care_icon {
        font-style: normal;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #07c160;
        color: #fff;
        position: absolute;
        top: 4px;
        right: 7px;
      }
    }
  }
}
</style>
